import { FullPost } from 'model';
import React from 'react';
// eslint-disable-next-line css-modules/no-unused-class
import postStyles from '../styles/posts.module.css';
export const PostContent: React.FC<{ post: FullPost; children: JSX.Element }> = ({ post, children }) => (
	<div>
		<div className={postStyles.postHeader}>
			<div className={postStyles.postTitle}>{post?.title}</div>
		</div>
		<div className={postStyles.postBody}>{children}</div>
	</div>
);
